import {
  SET_ENTITY_NAME,
  SET_MODULE_NAME,
  SET_NAME,
  SET_SELECTED_TYPE,
  SET_SELECTED_SHEET,
  SET_UPLOADED_FILE,
  SET_EXCEL_HEADERS,
  SET_ENTITY_LIST,
  SET_HISTORY_DATA,
  SET_MAPPING_DATA,
  SET_EDIT_MODE,
  SET_EDIT_DATA,
  RESET_TEMPLATE_MAPPING,
  CLEAR_FORM_FIELDS,
  LOADER_STATUS,
} from "./constants";

export const initialState = {
  entityName: "",
  moduleName: "",
  name: "",
  selectedType: "",
  selectedSheet: "",
  uploadedFile: null,
  excelHeaders: [],
  entityList: [],
  historyData: [],
  mappingData: {},
  editMode: false,
  editData: null,
  loaderStatus: false,
};

/* eslint-disable default-case, no-param-reassign */
const templateMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ENTITY_NAME:
      return {
        ...state,
        entityName: action.payload,
      };
    case SET_MODULE_NAME:
      return {
        ...state,
        moduleName: action.payload,
      };
    case SET_NAME:
      return {
        ...state,
        name: action.payload,
      };
    case SET_SELECTED_TYPE:
      return {
        ...state,
        selectedType: action.payload,
      };
    case SET_SELECTED_SHEET:
      return {
        ...state,
        selectedSheet: action.payload,
      };
    case SET_UPLOADED_FILE:
      return {
        ...state,
        uploadedFile: action.payload,
      };
    case SET_EXCEL_HEADERS:
      return {
        ...state,
        excelHeaders: action.payload,
      };
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityList: action.payload,
      };

    case SET_HISTORY_DATA:
      return {
        ...state,
        historyData: action.payload,
      };

    case SET_MAPPING_DATA:
      return {
        ...state,
        mappingData: action.payload,
      };

    case SET_EDIT_MODE:
      return {
        ...state,
        editMode: action.payload,
      };

    case SET_EDIT_DATA:
      return {
        ...state,
        editData: action.payload,
      };

    case RESET_TEMPLATE_MAPPING:
      return {
        ...initialState,
        entityList: state.entityList, // Keep entityList as it's loaded once
      };

    case CLEAR_FORM_FIELDS:
      return {
        ...state,
        entityName: "",
        moduleName: "",
        name: "",
        selectedType: "",
        selectedSheet: "",
      };

    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.payload,
      };

    default:
      return state;
  }
};

export default templateMappingReducer;
